export default "__VITE_ASSET__C2_0Y_Xp__"